import 'jquery-steps/build/jquery.steps';

import 'jquery-validation/dist/jquery.validate';

((
    ($) => {
        let _wizard = $("#wizard");
        let _form = _wizard.closest('form');

        const _validator = _form.validate({
            ignore: [],
            rules: {
                email: {
                    required: true,
                    email: true
                },
                first_name: {
                    required: true,
                    minlength: 3
                },
                last_name: {
                    required: true,
                    minlength: 3
                },
                amount: {
                    required: true,
                    number: true,
                    min: 3
                }
            }
        });

        const _valid = false;

        let _ajaxIsSending = false;

        let _wizardSteps = _wizard.steps({
            headerTag: "h3",
            bodyTag: "section",
            transitionEffect: "fade",
            autoFocus: true,
            titleTemplate: '#title#',
            enableAllSteps: false,
            onInit: function (event, currentIndex) {
                $('.actions > ul > li:first-child').attr('style', 'display:none');
                _wizard.closest('.lazyload-block').removeClass('lazyload-block');
                _form.stop().show();
            },
            onStepChanging: function (event, currentIndex, newIndex) {
                if (newIndex < currentIndex) {
                    return true;
                }
                const _content = _wizard.find('section[data-step="' + currentIndex + '"]');
                const _inputs = _content.find('[required]');

                const isValidStep = validateStep(_inputs);

                if (isValidStep === 0) {
                    return false;
                }

                return true;
            },
            onStepChanged: function (event, currentIndex, priorIndex) {
                if (currentIndex > 0) {
                    $('.actions > ul > li:first-child').attr('style', '');
                } else {
                    $('.actions > ul > li:first-child').attr('style', 'display:none');
                }
            },
            onFinishing: function (event, currentIndex) {
                const _content = _wizard.find('section[data-step="' + currentIndex + '"]');
                const _inputs = _content.find('[required]');

                const isValidStep = validateStep(_inputs);

                if (isValidStep === 0) {
                    return false;
                }

                return true;
            },
            onFinished: function (event, currentIndex) {
                const _url = _form.attr('action');
                const _method = _form.attr('method');
                const _data = _form.serialize();
                $.ajax({
                    url: _url,
                    method: _method,
                    data: _data,
                }).done((response) => {
                    if (response.status) {
                        _form.closest('.closets-w').html(response.html);
                        // _showConfirm(response.message, '', 'green');
                    }
                }).fail((response) => {
                    // _showConfirm(response.responseJSON.message, '', 'red');
                }).always((response) => {
                    _ajaxIsSending = false;
                });
            }
        });

        const validateStep = (_inputs) => {
            let _isValid = 1;
            _inputs.each(function (index, input) {
                const _input = $(input);
                let _valid = 1;
                if (_validator.element(_input) == false) {
                    _valid = 0;
                }
                _isValid = _isValid * _valid;
            });
            return _isValid;
        }

        // note
        $('#plan_duration_monthly').click(function () {
            const checked = $(this).prop('checked');
            if (checked) {
                $('#plan_duration_monthly_note').stop().show();
            }
        });
        $('#plan_duration_one_time').click(function () {
            $('#plan_duration_monthly_note').stop().hide();
        });

        $('.donation-note span').hover(function () {
            $('.donation-note-tooltip').show();
        }, function () {
            $('.donation-note-tooltip').hide();
        });

        $('#donation_custom_amount').click(function () {
            $('.suggest-boxes li input').prop('checked', '');
            $('#donation_amount').val(0);
        });

        $('#donation_custom_amount').on('change', function () {
            $('#donation_amount').val($(this).val());
        });

        $('.suggest-boxes li input').click(function () {
            $('#donation_custom_amount').val('');
            $('#donation_amount').val($(this).val());
        });

        // comment
        $('#leave_a_comment').on('click', function () {
            const _btn = $(this);
            if (!_btn.hasClass('open')) {
                _btn.addClass('open');
                $('#comment_box').stop().slideDown();
                $('#comment_box textarea').attr('required', 'required');
                _form.validate({
                    rules: {
                        comment: {
                            required: true,
                            minlength: 50
                        }
                    }
                });
            } else {
                _btn.removeClass('open');
                $('#comment_box').stop().slideUp();
                $('#comment_box textarea').removeAttr('required', 'required');
                _form.validate({
                    rules: {
                        comment: {
                            required: false
                        }
                    }
                });
            }
        });
    }
)
(jQuery));